module.exports = __webpack_public_path__ + "img/17.2f49ddac.png";